import React, { Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// const Profile = lazy(() => import('../views/profile/profile'));
const Profile = lazy(() => import('../views/profile/dashboardwizard'));
// const AddExperience = lazy(() => import("../views/profile/experience/addexperience"));
// const AddEducation = lazy(() => import("../views/profile/education/addeducation"));

const AppRoutes = () => 
{
    return (
        <Suspense fallback="loading...">
            <Switch>
                <Route exact path="/profile" component={Profile} />
                {/* <Route path="/views/profile/experience/addexperience" component={AddExperience} /> */}
                {/* <Route path="/views/profile/addeducation" component={AddEducation} /> */}
                <Redirect to="/profile" />
            </Switch>            
        </Suspense>
    );
}

export default AppRoutes;
